import { render, staticRenderFns } from "./dimension-detail.vue?vue&type=template&id=6b3e1de3&scoped=true&"
import script from "./dimension-detail.vue?vue&type=script&lang=ts&"
export * from "./dimension-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e1de3",
  null
  
)

export default component.exports